module.exports = __webpack_public_path__ + "static/header_bg-d8ac81aab95b58c0d5a7a34ea06b867f.svg";